<template>
    <div>
        <div class="text-left">
            <div class="modal-mask-v" v-if="showModal">
                <div class="modal-wrapper-v">
                    <div class="modal-container-v">
                        <div class="modal-header-v">
                            <slot name="header">
                                <!--default header override with slot-->
                            </slot>
                        </div>
                        <div class="modal-body-v">
                            <slot name="body">
                                <!--default body override with slot-->
                            </slot>
                        </div>
                        <div class="modal-footer-v">
                            <slot name="footer">
                                <button class="modal-default-button-v btn btn-primary"
                                        @click="showModal=!showModal;keepModalOpen()">{{btnCloseModalTitle}}
                                </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12">
            <!-- SHOW THE MODAL BTN-->
            <button id="show-modal" @click="showModal = true" class="btn btn-primary">{{btnOpenModalTitle}}</button>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            btnOpenModalTitle: String,
            btnCloseModalTitle: String,
            isSuperposedModal: false
        },
        data() {
            return {
                showModal: false,
            }
        },
        methods: {
            keepModalOpen() {
                console.log(this.isSuperposedModal);
                if (this.isSuperposedModal) {
                    document.body.style.position = "fixed";
                }
            }
        },
        watch: {
            showModal() {
                if (this.showModal === true || this.isSuperposedModal === true) {
                    document.body.style.position = "fixed";
                } else {
                    document.body.style.position = "inherit";
                }
            }
        }
    }
</script>

<style scoped>
    .modal-mask-v {
        position: fixed;
        z-index: 999999;
        top: 0;
        left: 0;
        width: 100%;
        height: 106%;
        background-color: rgba(7, 17, 30, 0.60);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper-v {
        display: table-cell;
        vertical-align: middle;
        height: 100%;
        width: auto;
        /*position:fixed;*/
        background-color: rgba(7, 17, 30, 0.60);
        padding: 4%;
        margin: 0px;
    }

    .modal-container-v {
        /*float: left;*/
        /*width: 100%;*/
        /*margin: 0px auto;*/
        /*!*padding: 60px 5px 5px 5px;*!*/
        background-color: #fff;
        border-radius: 4px;
        /*box-shadow: 0 2px 8px rgba(0, 0, 0, .33);*/
        /*transition: all .3s ease;*/
        /*font-family: Helvetica, Arial, sans-serif;*/
        /*height: 80%;*/
        overflow: scroll;
        padding: 8px;
        -webkit-overflow-scrolling: touch;
    }

    .modal-header-v {
        margin-top: 0;
        color: #42b983;
        border: 0px;
    }

    .modal-body-v {
        margin: 0;
        /*float: left;*/
        /*padding:0px;*/
        margin-top:10%;
    }

    .modal-default-button-v {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter-v {
        opacity: 0;
    }

    .modal-leave-active-v {
        opacity: 0;
    }

    .modal-enter-v .modal-container-v,
    .modal-leave-active-v .modal-container-v {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>